import {Button, Flex, HStack, Icon, Spinner, Text, VStack} from "@chakra-ui/react";
import {HiOutlineCpuChip, HiArrowRight} from "react-icons/hi2";
import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import ModelService from "@/services/agency/ModelService";
import AddAgentDrawer from "./components/AddAgentDrawer";

const AgentCard = ({agent}) => {
    const navigate = useNavigate();
    return (
        <HStack
            p={6}
            borderWidth={1}
            borderColor={'border.secondary'}
            w={'full'}
            borderRadius={12}
            bg={'bg.card'}
            columnGap={6}
            cursor={'pointer'}
            _hover={{bg: 'bg.highlight'}}
            transition="background 0.2s ease-in-out"
            onClick={() => navigate(`/models/${agent.id}`)}
        >
            <Icon fontSize={46} strokeWidth={0.75} color={'white'}>
                <HiOutlineCpuChip/>
            </Icon>
            <VStack alignItems={'flex-start'} gap={1} flex={1}>
                <Text color={'white'} fontWeight={500}>{agent.name}</Text>
                {agent.description && (
                    <Text color={'text.grey'} fontSize={13}>{agent.description}</Text>
                )}
            </VStack>
            <Icon fontSize={22} strokeWidth={1.5} color={'text.grey'}>
                <HiArrowRight/>
            </Icon>
        </HStack>
    );
};

const ModelsPage = () => {
    const [agents, setAgents] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);

    useEffect(() => {
        ModelService.getList().then((response) => {
            setAgents(response?.items ?? []);
        }).finally(() => setIsLoading(false));
    }, []);

    const handleCreate = (data) => {
        return ModelService.create(data).then((created) => {
            setAgents((prev) => [...prev, created]);
        });
    };

    if (isLoading) {
        return (
            <Flex w={'full'} py={24} alignItems={'center'} justifyContent={'center'}>
                <Spinner size={'xl'} color={'white'}/>
            </Flex>
        );
    }

    return (
        <VStack w={'full'} rowGap={6}>
            <Flex flexDirection={'row'} justifyContent={'flex-end'} w={'full'}>
                <Button variant="primary" textDecoration='unset' onClick={() => setIsDrawerOpen(true)}>
                    <Icon fontSize={46}>
                        <HiOutlineCpuChip/>
                    </Icon>
                    <Text>Add Agent</Text>
                </Button>
            </Flex>
            {agents.map((agent) => (
                <AgentCard key={agent.id} agent={agent}/>
            ))}
            <AddAgentDrawer
                isOpen={isDrawerOpen}
                onClose={() => setIsDrawerOpen(false)}
                onSave={handleCreate}
            />
        </VStack>
    );
};

export default ModelsPage;
